export function isArrayWithItems<T>(arr: any): arr is T[] {
  return Array.isArray(arr) && arr.length > 0;
}
